let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hlViZ")).then(() => parcelRequire('7VC0O'));